import React, {FC} from 'react'
import {SelectBox, Validator} from 'devextreme-react'
import clsx from 'clsx'
import {ISelectBoxOptions} from 'devextreme-react/select-box'
import {ValidationRules} from './Validation'
import {EmailRule, RequiredRule, StringLengthRule} from 'devextreme-react/validator'
import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles({
    simple: {
        display: 'flex',
        alignItems: 'center',
    },
    label: {
        width: 'auto',
    },
    value: {
        width: '100%',
    },
    auto: {
        width: 'auto',
    },
    dxSelect: {
        fontSize: 12,
    },
})

interface FormSelectProps extends ISelectBoxOptions {
    label: string
    validation?: ValidationRules
    isSimple?: boolean
    isAutoWidth?: boolean
}

export const FormSelect: FC<FormSelectProps> = (
    {
        label,
        className,
        validation,
        valueExpr,
        displayExpr,
        isSimple,
        isAutoWidth,
        ...selectProps
    }) => {
    const classes = useStyles()
    const maxLen = validation?.stringLengthRule ? typeof validation.stringLengthRule === 'boolean' ? 100 : validation.stringLengthRule : 100

    return (
        <div className={clsx('dx-field', !!isSimple && classes.simple, className)}>
            <div className={clsx('dx-field-label', !!isSimple && classes.label)}>{label}</div>
            <SelectBox
                className={clsx(!isSimple && 'dx-field-value', !!isSimple && !isAutoWidth && classes.value, !!isSimple && !!isAutoWidth && classes.auto, className)}
                valueExpr={valueExpr || 'value'}
                displayExpr={displayExpr || 'label'}
                {...selectProps}
            >
                {!!validation &&
                    <Validator>
                        {validation.requiredRule &&
                            <RequiredRule message="Field is required"/>}
                        {validation.emailRule &&
                            <EmailRule key="emailRule" message="Email is invalid"/>}
                        {validation.stringLengthRule &&
                            <StringLengthRule key="stringLengthRule" message={`Max length is ${maxLen} characters`}
                                              max={maxLen}/>}
                    </Validator>}
            </SelectBox>
        </div>
    )
}

export type SelectOption = {
    value: string | number,
    label: string,
    visible?: boolean
}
export const NewSelectOption = (value: string, label: string, visible?: boolean): SelectOption => {
    return {value, label, visible}
}

export type SelectBoxFilterProps = ISelectBoxOptions & {}
export const SelectBoxFilter: FC<SelectBoxFilterProps> = ({valueExpr, displayExpr, ...rest}) => {
    return <SelectBox valueExpr={valueExpr || 'value'} displayExpr={displayExpr || 'label'}{...rest}/>
}
